<ng-container *ngIf="loaded$ | async">
    <div class="dropdown" title="Versie" [class.open]="_open">
        <div class="selected" (click)="_open = !_open">
            <div class="item">{{ _versions?.[_selectedVersionId]?.description }}</div>
            <div class="opener">
                <i class="fas" [class.fa-arrow-down]="_open | not" [class.fa-arrow-up]="_open"></i>
            </div>
        </div>
        <div class="dropdown-container" [class.open]="_open">
            <ng-container *ngFor="let version of _versions; let i = index">
                <div class="item" [class.selected]="i | equals: _selectedVersion" (click)="_handleClickVersion(i)">
                    {{ version?.description }}
                </div>
            </ng-container>
        </div>
    </div>
    <i class="version-roll-forward fas fa-step-forward" title="Nieuwe versie maken" (click)="_handleClickCopyToNewVersion()"></i>
</ng-container>